import ScoringsPage from './ScoringsPage'

export default ScoringsPage
